import React, { useState, useEffect } from 'react';
import NoImage from 'assets/images/no-image.png';
import { FaSpinner, FaTimes } from 'react-icons/fa';


const ReceiptModalMobile = ({ openPopup, purchaseInvoice, handleClose, submitReceiptForm, selectedItems }) => {
    const [formInfo, setFormInfo] = useState({
        estimationId: '',
    });


    const [processingReceipt, setProcessingReceipt] = useState(false);



    return (
			<>
				<div
					className="d-flex"
					style={{
						width: '100vw',
						height: '100dvh',
						position: 'fixed',
						left: 0,
						top: 0,
						zIndex: 20,
						background: 'rgba(0,0,0,0.07)',
						justifyContent: 'center',
						alignItems: 'end',
						paddingBottom: '90px',
						backdropFilter: 'blur(8px)',
						WebkitBackdropFilter: 'blur(8px)'
					}}
				>
					<div
						className="popup product-popup-mobile d-md-none"
						style={{
							position: 'relative',
							transform: 'none',
							top: 0,
							left: 0,
							maxWidth: '90%',
							background: '#fff',
							borderRadius: 12,
							boxShadow: 'rgb(0 0 0 / 37%) 0px 0px 20px',
							width: '100%',
							padding: '24px 16px 0 16px',
							display: 'flex',
							flexDirection: 'column'
						}}
					>
						<div className="p-2">
							<div className="mb-2 ml-0 pl-0">
								<div className="row">
									<div className="col-12 text-left">
										<h5 className="h5 mb-0 text-gray-900 font-weight-bold flex-grow-1 pt-0" style={{ fontWeight: '600' }}>
											Add to stock
										</h5>
									</div>
								</div>
							</div>

							<div className="row align-items-top">
								<div className="col-12">
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											gap: '8px',
											backgroundColor: 'rgba(0,0,0,0.05)',
											borderRadius: 16,
											padding: 10
										}}
									>
										{selectedItems.map((item, index) => (
											<>
												<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
													<div style={{ display: 'flex', flexDirection: 'column' }}>
														<div style={{ fontWeight: 500 }}>{item?.product_name}</div>
														<div style={{}}>Incoming {item?.receiving_quantity} pcs</div>
													</div>

													<div>
														{item?.thumbnail_url ? (
															<img src={item.thumbnail_url} style={{ width: '100%', height: 50, objectFit: 'cover' }} alt="product" />
														) : item?.custom_thumbnail_url ? (
															// <img src={item.custom_thumbnail_url} style={{ width: '25px', height: '40px' }} alt="product" />
															<img
																src={item.custom_thumbnail_url}
																style={{ width: '100%', height: 50, objectFit: 'cover' }}
																alt="product"
															/>
														) : (
															<img src={NoImage} style={{ width: '100%', height: 50, objectFit: 'cover' }} alt="product" />
														)}
													</div>
												</div>
											</>
										))}
									</div>
								</div>
							</div>
							<div
								className="btnarea"
								style={{
									position: 'sticky',
									bottom: 0,
									left: 0,
									width: '100%',
									background: '#fff',
									padding: '16px 0 12px 0',
									zIndex: 30,
									display: 'flex',
									gap: 10,
									justifyContent: 'center',
									marginTop: 'auto'
								}}
							>
								<button
									className="btn btn-main-primary btn-outlined-main"
									disabled={true}
									onClick={() => {
										submitReceiptForm('with_imei');
									}}
								>
									{processingReceipt ? (
										<>
											<FaSpinner className="spinner" /> Processing...
										</>
									) : (
										<>With IMEI</>
									)}
								</button>
								<button
									onClick={() => {
										submitReceiptForm('without_imei');
									}}
									className="btn btn-main-primary btn-outlined-main"
									disabled={processingReceipt}
								>
									{processingReceipt ? (
										<>
											<FaSpinner className="spinner" /> Processing...
										</>
									) : (
										<>Without IMEI</>
									)}
								</button>
								<button className="btn btn-primary btn-outlined-main" onClick={handleClose}>
									Cancel
								</button>
							</div>
						</div>
					</div>
				</div>
			</>
		);
};

export default ReceiptModalMobile;
